import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';

const PrivateRoutes = () => {

  const { login } = useSelector((state: RootState) => state.auth);
  
  return (login === true) ? <Outlet /> : <Navigate to="/auth/login" replace />;
}

export default PrivateRoutes